module.exports = __webpack_public_path__ + "static/img/certify-banner-img.174ef866.png";